/* eslint-disable no-undef */

import api from '../api'

export const GET_HOMEPAGE = 'GET_HOMEPAGE'

export default {
  state: {dayPeriods: [], banners: []},
  mutations: {
    [GET_HOMEPAGE] (state, periods) {
      Object.assign(state, periods)
    }
  },
  actions: {
    [GET_HOMEPAGE] ({commit}, user) {
      return new Promise(function (resolve, reject) {
        api.getHomePage(user).then((data) => {
          commit(GET_HOMEPAGE, data)
          resolve()
        }, (data) => {
          commit(GET_HOMEPAGE, {dayPeriods: [], banners: []})
          reject(data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/homepage.js